(function($){

	if($('.articles_linked').length && !$('.popin_postpremium_subscribe_content').length){
		var $content_article = $('.c-article__txt');
		var $articles_linked = $('.articles_linked');
		var nb_p = $content_article.find("p").length;
		nb_p = Math.floor(nb_p/2);
		var paraf = $content_article.find('p:eq('+nb_p+')');
		$articles_linked.insertAfter(paraf); 
	}

})(jQuery);